import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../../constants/config";
import Preloader from "../Preloader";
import NetworkError from "../NetworkError";
import { Spinner } from "react-bootstrap";
import Select from "react-select";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import UserContext from "../../contexts/UserContext";
import RuleEsp from "./ruleesp";




export default function RulesProfil({profil, space}) {
    // states
    const {user, logoutUser} = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [addable, setAddable] = useState(false);
    const [error, setError] = useState(false);
    const [ruleslist, setRuleslist] = useState([]);
    const [rulescodelist, setRulescodelist] = useState([]);
    const [rulesobjectlist, setRulesobjectlist] = useState([]);

    const [rules, setRules] = useState("");
    const [rulesalllist, setRulesalllist] = useState([]);

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const getAllListRules = async () => {
        // setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/workspaces/${space}?type=droit`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        
                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({label: element.libdroit, value: element.codedroit});
                        });

                        setRulesalllist(clientarraydata);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("data error: fail");
            }
            
        })
        .catch((err) => {
            // console.log("cash error: ", err);;
        });
    }


    const getListRules = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/profiles/rights/${profil}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraycode = [];
                        await clientarray.forEach(element => {
                            clientarraycode.push(element.codedroit);
                        });

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({label: element.libdroit, value: element.codedroit});
                        });

                        // console.log("liste in data", clientarraydata)
                        setRuleslist(clientarray);
                        setRulescodelist(clientarraycode);
                        setRulesobjectlist(clientarraydata);
                        setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
            
        })
        .catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }
    
    
            // console.log("list 3", rulesobjectlist);


    // comportements
    useEffect(() => {
        getAllListRules();
        getListRules();
    }, []);

    const handleSetUpsdate = () => {
        setRules(rulesobjectlist);
        setAddable(true);
    }

    const handleDelete = async (codedroit) => {

        const objectrules = [...rulesobjectlist];

        for (let i = 0; i < objectrules.length; i++) {
            const element = objectrules[i];
            if (element.value === codedroit) {
                objectrules.splice(i, 1);
                setRulesobjectlist(objectrules);
            }
        }

        confirmAlert({
            title: 'Remove?',
            message: 'Are you sure you want to remove this privilege to this profile?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);
                        // console.log("list 2: ", objectrules);
                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();
                        urlencoded.append("codedroit", objectrules.map((i) => i["value"]));

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/profiles/rights/${profil}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                setFetching(false);
                                showSuccesMessage("Privilege removed successfully.");
                                getListRules();
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    let body = data?.body?.data;

                                    if (body.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(body.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setFetching(false);
                            }
                            
                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(config.texts.unavailblemsg);
                            setFetching(false);
                        });
                    }
                }, 
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        urlencoded.append("codedroit", rules.map((i) => i["value"]));

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/profiles/rights/${profil}`, requestOptions).then((response) => {
            if (response?.status === 204) {
                setFetching(false);
                showSuccesMessage("Privileges of profile grant update successfully");
                setAddable(false);
                getListRules();
            } else if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse update rule", data);
                    let body = data?.body?.data;

                    if (body.msg === "expiredsession") {
                        logoutUser();
                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                    } else {
                        setFetching(false);
                        showErrorMessage(body.msg);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // setError(true);
                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                setFetching(false);
            }
            
        })
        .catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(config.texts.unavailblemsg);
            setFetching(false);
        });
    }

    // console.log("objet list: ", rulesobjectlist);

    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="row">
                <div className="col-md-12 mb-3 pt-3 rounded" style={{borderTop: "1px solid #ccc"}}>
                    <div className="row">
                        {/* <div className="col-md-2 mb-3">  
                            <PaginationSelect table={"scan"} getList={getListRules} page={page} setPage={setPage} limit={100} current={currentpage} setCurrent={setCurrentpage} />
                        </div>
                        <div className="col-md-10 mb-3">
                            <Search 
                                chaine={chaine}
                                setChaine={setChaine}
                                search={searchScan}
                                placeholder="Search by access name..."
                            />
                            <Filterdate 
                                date={date}
                                setDate={setDate}
                                filterdate={filterByDate}
                                placeholder="Filter by date..."
                            />
                            <Filterselect 
                                list={list}
                                item={mode}
                                setItem={setMode}
                                filterselect={filterByMode}
                                placeholder="Filter by access types..."
                            />
                        </div> */}
                        {!addable && <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    <button type="button" data-toggle="tooltip" onClick={handleSetUpsdate}
                                        title="Update profile privileges" 
                                        data-placement="left" className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                        <i className="fa fa-edit mr-1"></i> <span>Update</span>
                                    </button>
                                    <h6 className="m-0 ">List of privileges of this profile</h6>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive mb-3">
                                        <table className="mb-0 table table-bordered">
                                            <thead className="bg-primary">
                                                <tr className="bg-primary text-white">
                                                    <th className="text-center">#</th>
                                                    <th>Name</th>
                                                    <th>Action code</th>
                                                    {/* <th>Parent</th>
                                                    <th>Etat</th>
                                                    <th>Date d'affectation</th> */}
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(ruleslist.length === 0) && <tr style={{borderStyle: "none"}}>
                                                    <th colSpan={4} className="text-center">No privilege found for this profile</th>
                                                </tr>}
                                                {
                                                    (ruleslist.length > 0) && ruleslist?.map((item, index) => (
                                                        <RuleEsp rule={item} position={index} key={index} 
                                                            deleteClick={() => handleDelete(item?.codedroit)}
                                                        />
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <Pagination table={"client"} getList={getListRules} page={page} setPage={setPage} /> */}
                                </div>
                            </div>
                        </div>}
                        {addable && <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    <button type="button" data-toggle="tooltip" onClick={() => setAddable(false)}
                                        title="Cancel update" 
                                        data-placement="left" className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                        <i className="fa fa-backward mr-1"></i> <span>Cancel</span>
                                    </button>
                                    <h6 className="m-0 ">Update privileges granted for this profile</h6>
                                </div>
                                <div className="card-body">
                                    <form style={{width: "100%"}} onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <div className="row">
                                                    
                                                    <div className="col-md-12 mb-3">
                                                        <label className="mb-1" htmlFor="parent">Privileges</label>
                                                        <Select
                                                            id="parent"
                                                            name="parent"
                                                            options={rulesalllist}
                                                            value={rules}
                                                            placeholder="Select privileges to grant"
                                                            onChange={(selected) => { 
                                                                setRules(selected);
                                                            }}
                                                            isMulti
                                                        />
                                                    </div>
                                                    
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-12 mt-2">
                                                <button type="submit" 
                                                    title="Update profile privileges" 
                                                    className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                    disabled={rules ? false : true}
                                                >
                                                    <i className="fa fa-check mr-2"></i> 
                                                    <span>Update</span> {fetching && <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                    />}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>} 
        </>
    )
    
}